import './filter-editor.css'
import { useState, useEffect, useContext } from 'react';
import BtnDelSvg from '../../creators/taskCreator/btn-del-svg';
import BtnEditSvg from '../../creators/taskCreator/btn-edit-svg';
import BtnAddSvg from '../../creators/taskCreator/btn-add-svg';
import API from '../../API';
import { Navigate } from 'react-router-dom';
import Context from '../../context';
import { ru } from '../../data/ru';
import { by } from '../../data/by';

const FilterEditor = () => {
    let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;

    const {mainState} = useContext(Context)

    const [newCat, setNewCat] = useState('');
    const [tagsData, setTagsData] = useState(null);
    const [tagKeys, setTagKeys] = useState([]);
    const [tagValues, setTagValues] = useState([]);
    const [editCategoryIndex, setEditCategoryIndex] = useState(-1);
    const [isNewCat, setIsNewCat] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [categoriesData, setCategoriesData] = useState([]);
    let _api = new API();

    const strToColor = (str) => {
        let count = 0;
        str.split('').map((symb) => {
            count += symb.charCodeAt(0);
        })
        count = count * 4 % 360;
        return 'hsl(' + count + ' 90% 40%)';
    }

    const getNewServerData = () => {
        _api.getFilters()
        .then(data => {
            setTagsData(data);
            return data;
        }).then((tagdata) => {
            _api.getCategories()
                .then(data => {
                    let oldTagKeys = Object.keys(tagdata)
                    let oldTagValues = Object.values(tagdata)
                    let newTagKeys = []
                    let newTagValues = []
                    let newCatData = [];

                    data.map((item, index) => {
                        if (oldTagKeys.includes(item.name) ){
                            let countIndex = oldTagKeys.indexOf(item.name)
                            newTagKeys = [oldTagKeys[countIndex], ...newTagKeys];
                            newTagValues = [oldTagValues[countIndex], ...newTagValues];
                            newCatData = [item, ...newCatData];
                        } else {
                            newTagKeys = [ item.name, ...newTagKeys];
                            newTagValues = [ [], ...newTagValues];
                            newCatData = [item, ...newCatData];
                        }
                    })
                    setCategoriesData(newCatData);
                    setTagKeys(newTagKeys);
                    setTagValues(newTagValues);
                });
        })
    }

    useEffect(() => {
        
        getNewServerData();

    }, [])

    

    const changeCategoryName = (value, id) => {
        let newTagKeys = []
        tagKeys.map((item, index) => {
            if (index === id) {
                newTagKeys = [...newTagKeys, value]
            } else {
                newTagKeys = [...newTagKeys, item]
            }
        })
        setTagKeys(newTagKeys);
    }

    const changeTagName = (value, id1, id2) => {
        let newTagValues = []
        tagValues.map((item, index) => {
            if (index === id1) {
                let newItem = [];
                item.map((e, i) => {
                    if (i === id2) {
                        newItem = [...newItem, { id: '', name: value }]
                    } else {
                        newItem = [...newItem, e]
                    }
                })
                newTagValues = [...newTagValues, newItem]

            } else {
                newTagValues = [...newTagValues, item]
            }
        })
        setTagValues(newTagValues);
    }

    const addTagToCategory = (e, id) => {
        setIsEditing(true);
        let newTagValues = []
        tagValues.map((item, index) => {
            if (index === id) {
                let newItem = [...item, { id: '', name: '' }]
                newTagValues = [...newTagValues, newItem]
            } else {
                newTagValues = [...newTagValues, item]
            }
        })
        setTagValues(newTagValues);
    }

    const delTagInputFromCategory = (e, id1, id2) => {
        setIsEditing(false);

        let newTagValues = []
        tagValues.map((item, index) => {
            if (index === id1) {
                let newItem = [];
                item.map((e, i) => {
                    if (i !== id2) {
                        newItem = [...newItem, e]
                    }
                })
                newTagValues = [...newTagValues, newItem]
            } else {
                newTagValues = [...newTagValues, item]
            }
        })
        setTagValues(newTagValues);
    }

    const addCatInput = (index1) => {
        setIsEditing(true);
        setEditCategoryIndex(index1)
    }
    const delCatInput = (index1) => {

        setIsEditing(false);
        let newTagKeys = []
        tagKeys.map((item, index) => {
            if (index !== index1) {
                newTagKeys = [...newTagKeys, item]
            } else {
                newTagKeys = [...newTagKeys, Object.keys(tagsData)[index1]]
            }
        })
        setTagKeys(newTagKeys)
        setEditCategoryIndex(-1)
    }



    const sendCat = (index) => {
        setIsEditing(false);
        let catId = categoriesData[index].id;
        _api.editCategory(catId,{
            name: tagKeys[index],
        }).then(() => {
            getNewServerData();
        });
    }

    const sendDelCat = (index) => {
        let catId = categoriesData[index].id;
        if(window.confirm(`Хотите удалить категорию ${categoriesData[index].name}?`))
        _api.deleteCategory(catId).then(() => {
            getNewServerData()
        })
    }

    const sendDelTag = (index1, index2) => {
        let tagId = tagValues[index1][index2].id;
        _api.deleteFilter(tagId).then(() => {getNewServerData()
             })
    }

    const sendNewCat = () => {
        setIsEditing(false);
        setIsNewCat(false);
        _api.addCategory({
            name: newCat,
            tags: []
        }).then(() => {
            getNewServerData()
        })

    }

    const sendTag = (index1, index2) => {
        setIsEditing(false);
        let catId = categoriesData[index1].id;
        _api.addFilters(catId,{
            tags: [tagValues[index1][index2].name]
        }).then(() => {
            getNewServerData()
        });
    }

    return (
        <div className='fl-editor-main'>

            {mainState.isLoggedIn && (mainState.type === "Editor" ||mainState.type === "Admin" ) ?


            <div className='fl-editor-content'>

                <div className='fl-editor-item1'>
                    {!isNewCat ?
                        <button className='fl-editor-add-btn' onClick={() => { setIsNewCat(true); setIsEditing(true); }} disabled={isEditing}>{language.filterCreateCategory}</button>
                        :
                        <div className='fl-editor-newcat-box'>
                            <div className='fl-editor-item2'>
                                <input className='fl-editor-cat-input' type='text' value={newCat} onChange={e => { setNewCat(e.target.value) }} />
                                <button className='fl-editor-svg-btn' onClick={e => { sendNewCat();}}><BtnAddSvg customFill={"white"} /></button>
                                <button className='fl-editor-svg-btn' onClick={e => { setIsNewCat(false); setNewCat(''); setIsEditing(false) }}><BtnDelSvg customFill={"white"} /></button>
                            </div>
                        </div>
                    }
                </div>
                {tagKeys.map((item1, index1) => {
                    return (
                        <div key={'k' + index1} className='fl-editor-item1'>

                            <div className='fl-editor-item1-toprow'>
                                {editCategoryIndex !== index1 ?
                                    <div className='fl-editor-item2'>
                                        {item1}
                                        <button className='fl-editor-svg-btn' onClick={e => { addCatInput(index1) }} disabled={isEditing}><BtnEditSvg customFill={"white"} /></button>
                                        <button className='fl-editor-svg-btn' onClick={e => {sendDelCat(index1);}} disabled={isEditing}><BtnDelSvg customFill={"white"} /></button>
                                    </div>
                                    :
                                    <div className='fl-editor-item2'>
                                        <input className='fl-editor-cat-input' type='text' value={item1} onChange={e => changeCategoryName(e.target.value, index1)} />
                                        <button className='fl-editor-svg-btn' onClick={e => { sendCat(index1);setEditCategoryIndex(-1) }}><BtnAddSvg customFill={"white"} /></button>
                                        <button className='fl-editor-svg-btn' onClick={e => { delCatInput(index1); }}><BtnDelSvg customFill={"white"} /></button>
                                    </div>
                                }

                            </div>
                            {tagValues[index1] &&
                                tagValues[index1].map((item2, index2) => {
                                    if (item2.id !== '') {
                                        return (
                                            <div className='fl-editor-item2' style={{ color: strToColor(item2.name) }} key={'t' + index2}>
                                                {item2.name}
                                                <button className='fl-editor-svg-btn' onClick={e => { sendDelTag(index1, index2) }} disabled={isEditing}><BtnDelSvg /></button>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className='fl-editor-item2' style={{ color: strToColor(item2.name) }} key={'t' + index2}>
                                                <input style={{ color: strToColor(item2.name) }} type={'text'} onChange={e => changeTagName(e.target.value, index1, index2)} />
                                                <button className='fl-editor-svg-btn' onClick={e => sendTag(index1, index2)}><BtnAddSvg /></button>
                                                <button className='fl-editor-svg-btn' onClick={e => delTagInputFromCategory(e, index1, index2)}><BtnDelSvg /></button>
                                            </div>
                                        )
                                    }
                                })
                            }
                            <div className='fl-editor-item1-botrow'>
                                <div className='fl-editor-item2'>
                                    <button className='fl-editor-svg-btn' onClick={e => addTagToCategory(e, index1)} disabled={isEditing}><BtnAddSvg customFill={"white"} /></button>
                                </div>
                            </div>
                        </div>

                    )
                })}
            </div>
            : <Navigate to="/*"/>}
        </div>
    )
}

export default FilterEditor;